export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

export function dateFormat(date) {
  var day = date.getDate()
  var month = date.getMonth() + 1
  var year = date.getFullYear()
  return year+'-'+month+'-'+day
}

export function deleteCookie(name) {
  document.cookie = name+'=; Max-Age=-99999999; path=/;';
}

export function setLocalStorage(storageid, data) {
  window.localStorage.setItem(storageid, JSON.stringify(data))
}

export function getLocalStorage(storageid) {
  var data = window.localStorage.getItem(storageid)
  return data ? JSON.parse(data) : {}
}
 
